import guestClient from '../config/api/guestClient';
import userClient from '../config/api/userClient';
var loginUrl = "login";
var getUserInfoUrl = "users";
var getUserExternalInfoUrl = "publishers";
var forgotPasswordRequest = "password/request";
var getOperatorUrl = "users/operators";
var systemPropertiesUrl = "system/properties/all";
export var login = function (data) {
    return guestClient.post(loginUrl, data);
};
export var getUserInfo = function (userId) {
    return userClient.get(getUserInfoUrl + ("/" + userId));
};
export var getSystemProperties = function () {
    return userClient.get(systemPropertiesUrl);
};
export var getListUsers = function () {
    return userClient.get(getUserInfoUrl);
};
export var getListUsersForExternal = function (idPublisher) {
    return userClient.get(getUserExternalInfoUrl + ("/" + idPublisher + "/includeUsers"));
};
export var getListUsersByPubForExternal = function (id, params) {
    return userClient.get(getUserExternalInfoUrl + ("/" + id + "/includeManyUsers"), { params: params });
};
export var forgotPassword = function (param) {
    return guestClient.get(forgotPasswordRequest, { params: param });
};
export var getListOperators = function () {
    return userClient.get(getOperatorUrl);
};
